import React from 'react';

/** Instagram favourite facts that require auth before showing values publicly. */
export const INSTAGRAM_FACTS_SHIELDED_WHEN_UNAUTH = [
  'Engagement Rate',
  'Views',
  'Average Views Per Post',
  'Account Reach'
];

/** Single canonical label for the paid Instagram “highest engagement” stat. */
export const INSTAGRAM_FACT_NAME_HIGHEST_ENGAGEMENT = 'Highest engagement';

export const isInstagramStatShieldedWhenUnauthenticated = stat =>
  stat?.socialChannelName?.toLowerCase() === 'instagram' &&
  INSTAGRAM_FACTS_SHIELDED_WHEN_UNAUTH.includes(stat?.factName);

const isNumericValue = val =>
  /^-?\d+(\.\d+)?$/.test(String(val ?? '').trim());

/** Renders a trailing "%" a bit smaller than the number it follows. */
const withScaledPercentSign = value => {
  const str = typeof value === 'string' ? value : String(value ?? '');
  if (!str.endsWith('%')) return value;
  return (
    <p>
      {str.slice(0, -1)}
      <span className='text-[0.7em] align-bottom'>%</span>
    </p>
  );
};

export const filterFavFactsForApi = factsListLocal =>
  (factsListLocal || []).filter(item => item?.factName && item?.socialChannelName);

export const renderFavouriteFactValue = ({
  stat,
  isInstagramAuthenticated,
  formatNumber,
  renderShield
}) => {
  const raw = stat?.factValue;
  const factName = stat?.factName;

  if (factName === 'Age Range' || factName === 'Ilola Rating') {
    return withScaledPercentSign(raw || 0);
  }

  if (isInstagramStatShieldedWhenUnauthenticated(stat) && !isInstagramAuthenticated) {
    return renderShield();
  }

  if (isNumericValue(raw)) {
    return formatNumber(raw, 1, true) || 0;
  }

  return withScaledPercentSign(raw || '');
};
